import { useCallback } from 'react';

import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { fetchRecentResultsAction } from '../apiActions/fetchRecentResultsAction';

export const useRecentResultFetcher = (force: boolean = false): (() => void) => {
  const dispatch = useCoreDispatch();
  const recentResultsCount = 500;
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const tableId = useConfigSlice.tableId();
  const baseUrl = useConfigSlice.baseUrl();

  return useCallback(() => {
    if (recentResultsCount && JSESSIONID && baseUrl && tableId) {
      dispatch(
        fetchRecentResultsAction({
          JSESSIONID,
          tableId,
          numberOfGames: recentResultsCount,
          url: `${baseUrl}/api/ui/statisticHistory`,
          force: force,
        })
      );
    }
  }, [JSESSIONID, baseUrl, tableId, dispatch, force]);
};
